/*eslint-disable*/
import React from 'react';

// reactstrap components
import { Container, Row } from 'reactstrap';

// core components

function FooterWhite() {
  return (
    <>
      <footer className="footer footer-white">
        <Container>
          <Row>
            <nav className="footer-nav">
              <ul>
                <li>
                  <a
                    href="https://www.instagram.com/calisthenicsforayear/"
                    target="_blank"
                    className="mr-1"
                  >
                    @calisthenicsforayear
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.sxfigure.com/"
                    target="_blank"
                    className="mr-1"
                  >
                    sxFigure
                  </a>
                </li>
              </ul>
            </nav>
            <div className="credits ml-auto">
              <span className="copyright">
                © {new Date().getFullYear()}
                , CFAY & SXF collaboration
              </span>
            </div>
          </Row>
        </Container>
      </footer>
    </>
  );
}

export default FooterWhite;
